import React, { useEffect, useState } from 'react';
import { getAllComments, approveComment } from '../../utils/api'; // עדכני לנתיב שלך
import { Button } from '../ui/button.jsx';

export default function AdminComments() {
    const [comments, setComments] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadComments();
    }, []);

    const loadComments = async () => {
        setLoading(true);
        try {
            const { data } = await getAllComments();
            setComments(data);
        } catch (err) {
            alert("בעיה בטעינת התגובות.");
        }
        setLoading(false);
    };

    const handleApprove = async (id) => {
        try {
            await approveComment(id);
            setComments(comments =>
                comments.map(c => c._id === id ? { ...c, isApproved: true } : c)
            );
        } catch {
            alert("בעיה באישור תגובה.");
        }
    };

    return (
        <div className="container max-w-2xl mx-auto py-12">
            <h1 className="text-2xl font-bold mb-6">תגובות שממתינות לאישור</h1>
            {loading ? (
                <p>טוען...</p>
            ) : (
                <>
                    {comments.filter(c => !c.isApproved).length === 0 ? (
                        <div>אין תגובות לאישור כרגע.</div>
                    ) : (
                        comments
                            .filter(c => !c.isApproved)
                            .map(comment => (
                                <div key={comment._id} className="border rounded-lg p-4 mb-4 bg-yellow-50">
                                    <div className="mb-2">
                                        <b>{comment.author?.fullName || "אנונימי"}</b>
                                        {comment.post?.title && <span> על "<b>{comment.post.title}</b>"</span>}
                                    </div>
                                    <div className="mb-2" dangerouslySetInnerHTML={{ __html: comment.content }} />
                                    <Button onClick={() => handleApprove(comment._id)}>
                                        אשר תגובה
                                    </Button>
                                </div>
                            ))
                    )}
                </>
            )}
        </div>
    );
}
